import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { authRedirection } from '../../../core/config/auth-redirection';



@Injectable({
  providedIn: 'root'
})
export class LoggedInAuthGuard implements CanActivate {

  constructor(private _authService: AuthService, private _router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userToken = localStorage.getItem('access_token');


    switch (true) {
      case !userToken:

        return true;

      default:
        const userRole = this._authService.getUserDetails(userToken)['role'];
        const redirectionRule = authRedirection.find(rule => rule.role === userRole);
        this._router.navigate([redirectionRule.loggedInredirectTo]);
        return false;
    }

  }
}

